import type { WorkGenreLink } from "@/types/taxonomy";

/**
 * 作品とジャンルの多対多リンク、および詳細属性（デモデータ）。
 * 外部API連携時は、このリンクテーブルをAPIレスポンスから生成する。
 * 1件の作品に複数のジャンルIDを紐付けられる。
 */

export const workGenreLinks: WorkGenreLink[] = [
  {
    workId: "WK-0001",
    genreIds: ["g-fantasy", "g-adventure", "g-emotion", "g-long", "g-quiet", "g-travel"],
    attributes: [
      { attributeId: "at-volume", value: "118" },
      { attributeId: "at-format", value: "HD" },
    ],
  },
  {
    workId: "WK-0002",
    genreIds: ["g-action", "g-sf", "g-dark", "g-series", "g-robot", "g-battle"],
    attributes: [{ attributeId: "at-pages", value: "224" }],
  },
  {
    workId: "WK-0003",
    genreIds: ["g-mystery", "g-suspense", "g-short", "g-night", "g-partner"],
    attributes: [
      { attributeId: "at-volume", value: "96" },
      { attributeId: "at-format", value: "HD" },
    ],
  },
  {
    workId: "WK-0004",
    genreIds: ["g-romance", "g-comedy", "g-youth", "g-night"],
    attributes: [{ attributeId: "at-pages", value: "168" }],
  },
  {
    workId: "WK-0005",
    genreIds: ["g-history", "g-drama", "g-long", "g-quiet", "g-ensemble"],
    attributes: [{ attributeId: "at-pages", value: "412" }],
  },
  {
    workId: "WK-0006",
    genreIds: ["g-sf", "g-action", "g-robot", "g-quiet", "g-series"],
    attributes: [{ attributeId: "at-volume", value: "104" }],
  },
  {
    workId: "WK-0007",
    genreIds: ["g-horror", "g-mystery", "g-short", "g-night", "g-rain"],
    attributes: [{ attributeId: "at-pages", value: "156" }],
  },
  {
    workId: "WK-0008",
    genreIds: ["g-horror", "g-occult", "g-anthology", "g-night", "g-mystery"],
    attributes: [{ attributeId: "at-pages", value: "198" }],
  },
  {
    workId: "WK-0009",
    genreIds: ["g-history", "g-action", "g-series", "g-battle", "g-long"],
    attributes: [{ attributeId: "at-pages", value: "320" }],
  },
  {
    workId: "WK-0010",
    genreIds: ["g-sf", "g-drama", "g-emotion", "g-travel", "g-quiet", "g-long"],
    attributes: [{ attributeId: "at-volume", value: "142" }],
  },
  {
    workId: "WK-0011",
    genreIds: ["g-music", "g-drama", "g-musicdrama", "g-voice", "g-night"],
    attributes: [{ attributeId: "at-tracks", value: "8" }],
  },
  {
    workId: "WK-0012",
    genreIds: ["g-suspense", "g-mindgame", "g-series", "g-battle", "g-rival"],
    attributes: [{ attributeId: "at-pages", value: "236" }],
  },
  {
    workId: "WK-0013",
    genreIds: ["g-action", "g-suspense", "g-long", "g-battle"],
    attributes: [{ attributeId: "at-volume", value: "126" }],
  },
  {
    workId: "WK-0014",
    genreIds: ["g-romance", "g-daily", "g-youth", "g-cafe", "g-healing", "g-summer"],
    attributes: [{ attributeId: "at-pages", value: "180" }],
  },
  {
    workId: "WK-0015",
    genreIds: ["g-romance", "g-fantasy", "g-anthology", "g-healing", "g-short"],
    attributes: [{ attributeId: "at-pages", value: "208" }],
  },
  {
    workId: "WK-0016",
    genreIds: ["g-romance", "g-drama", "g-adult", "g-series"],
    attributes: [{ attributeId: "at-volume", value: "112" }],
  },
  {
    workId: "WK-0017",
    genreIds: ["g-fantasy", "g-mystery", "g-quiet", "g-library", "g-night"],
    attributes: [{ attributeId: "at-pages", value: "192" }],
  },
  {
    workId: "WK-0018",
    genreIds: ["g-romance", "g-comedy", "g-office", "g-workplace"],
    attributes: [{ attributeId: "at-volume", value: "88" }],
  },
  {
    workId: "WK-0019",
    genreIds: ["g-daily", "g-healing", "g-anthology", "g-short"],
    attributes: [{ attributeId: "at-pages", value: "144" }],
  },
  {
    workId: "WK-0020",
    genreIds: ["g-romance", "g-cooking", "g-daily", "g-series", "g-night"],
    attributes: [{ attributeId: "at-pages", value: "212" }],
  },
  {
    workId: "WK-0021",
    genreIds: ["g-romance", "g-office", "g-adult", "g-short"],
    attributes: [{ attributeId: "at-pages", value: "176" }],
  },
  {
    workId: "WK-0022",
    genreIds: ["g-youth", "g-drama", "g-emotion", "g-summer", "g-nostalgic"],
    attributes: [{ attributeId: "at-volume", value: "94" }],
  },
  {
    workId: "WK-0023",
    genreIds: ["g-romance", "g-comedy", "g-long", "g-partner"],
    attributes: [{ attributeId: "at-pages", value: "248" }],
  },
  {
    workId: "WK-0024",
    genreIds: ["g-daily", "g-essay", "g-photobook", "g-travel", "g-rain"],
    attributes: [{ attributeId: "at-pages", value: "128" }],
  },
  {
    workId: "WK-0025",
    genreIds: ["g-youth", "g-romance", "g-school", "g-nostalgic", "g-partner"],
    attributes: [{ attributeId: "at-pages", value: "164" }],
  },
  {
    workId: "WK-0026",
    genreIds: ["g-romance", "g-fantasy", "g-adult", "g-anthology"],
    attributes: [{ attributeId: "at-pages", value: "200" }],
  },
  {
    workId: "WK-0027",
    genreIds: ["g-fantasy", "g-short", "g-anthology", "g-quiet", "g-anthology-mag"],
    audienceIds: ["male"],
    attributes: [{ attributeId: "at-pages", value: "52" }],
  },
  {
    workId: "WK-0028",
    genreIds: ["g-romance", "g-daily", "g-cafe", "g-healing", "g-comedy"],
    audienceIds: ["female"],
    attributes: [{ attributeId: "at-platform", value: "Windows / macOS" }],
  },
  {
    workId: "WK-0029",
    genreIds: ["g-collection", "g-figure", "g-fantasy"],
    audienceIds: ["common"],
    attributes: [{ attributeId: "at-size", value: "150" }],
  },
  {
    workId: "WK-0030",
    genreIds: ["g-short", "g-quiet"],
    audienceIds: ["unclassified"],
    attributes: [{ attributeId: "at-pages", value: "120" }],
  },
  {
    workId: "WK-0031",
    genreIds: ["g-sf", "g-drama", "g-winter", "g-quiet", "g-night"],
    audienceIds: ["male"],
    attributes: [
      { attributeId: "at-volume", value: "108" },
      { attributeId: "at-format", value: "HD" },
    ],
  },
];